<template>
  <tabs parent="production">
    <tab
      id="order_list"
      :name="translate('production.many')"
      :href="url+'/order_list'"
    >
      <OrderList/>
    </tab>

    <tab
      id="specifications"
      :name="translate('production_plan.many')"
      :href="url+'/specifications'"
    >
      <Specifications />
    </tab>
  </tabs>
</template>

<script>
import OrderList from './Tabs/OrderList/Index.vue'
import Specifications from './Tabs/Specifications/Index.vue'

import {Tabs, Tab} from 'components/UIComponents/Tabs'

export default {
  name: 'Production',
  components: {
    Tabs,
    Tab,
    OrderList,
    Specifications
  },
  data () {
    return {
      active: false,
      servers: [],
      loading: true,
      groups_servers: []
    }
  },

  computed: {
    url () { return '/production' }
  },
}
</script>
